import API_URLS from "constants/apis.url.js";

import { getPage } from "../utils/utils.js";
import { extractSystemId } from "../utils/utils.js";

import { deleteRequest, getRequest, postRequest, putRequest } from "./api.js";

export const getAddLayoutData = () => {
  const page = formatLayoutName(getPage());
  return getRequest(`/${page}`);
};

const formatLayoutName = name => name.toLowerCase();

export const getAllUsers = async () => {
  const URL = `${API_URLS.adminSystemsURL}/${extractSystemId()}/layout/users`;
  const response = await getRequest(URL, false);
  return response.data;
};
export const getUsersSystem = async (page, user) => {
  const URL = `${API_URLS.adminLayoutURL}/${page}/users/${user.UserId}`;
  const response = await getRequest(URL, false);
  return response.data;
};
export const getUsersLayout = async (page, systemId, user) => {
  const URL = `${API_URLS.adminSystemsURL}/${systemId}/layouts/${page}/users/${user.UserId}`;
  const response = await getRequest(URL, false);
  return response.data;
};

export const addLayoutRequest = async (page, LayoutName, Home, AddToUser = null, AddFromLayout = null, Scheduling = null, AutoReport, baselineId = null) => {
  const payload = { LayoutName, Home, AddToUser, AddFromLayout, Scheduling, AutoReport };
  if (baselineId !== null) {
    payload.baselineId = baselineId;
  }

  return await postRequest(`/${formatLayoutName(page)}`, payload);
};

export const editLayoutRequest = async (page, oldLayoutName, LayoutID, LayoutName, Home, Scheduling, AutoReport) => {
  const URL = `/${formatLayoutName(page)}/${LayoutID}`;
  const payload = { Home, LayoutName, Scheduling, AutoReport };
  return await putRequest(URL, payload);
};

export const deleteLayoutRequest = async (page, id) => await deleteRequest(`/${formatLayoutName(page)}/${id}`);
